import {
  PP_LEADS_FETCH_START,
  PP_LEADS_FETCH_SUCCUSS,
  PP_LEADS_FETCH_FAIL,
  P24_LEADS_FETCH_START,
  P24_LEADS_FETCH_SUCCUSS,
  P24_LEADS_FETCH_FAIL,
  PP_LISTINGS_ACTIVITY_FETCH_START,
  PP_LISTINGS_ACTIVITY_FETCH_SUCCUSS,
  PP_LISTINGS_ACTIVITY_FETCH_FAIL,
  FETCH_PPREF,
  FETCH_PPREF_SUCCESS,
  FETCH_PPREF_FAIL
} from "../store/types";

export const INITIAL_STATE = {
  ppleads: null,
  p24leads: null,
  loading: false,
  ppstatus: null,
  ppref: null,
  p24status: null,
  success: false,
  completed: false,
  error: {
    flag: false,
    msg: null
  }
};

export const leadsreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PP_LEADS_FETCH_START:
      return {
        ...state,
        loading: true
      };
    case PP_LEADS_FETCH_SUCCUSS:
      return {
        ...state,
        ppleads: action.payload,
        loading: false,
        completed: true,
        success: true
      };
    case PP_LEADS_FETCH_FAIL:
      return INITIAL_STATE;

    case P24_LEADS_FETCH_START:
      return {
        ...state,
        loading: true
      };
    case P24_LEADS_FETCH_SUCCUSS:
      return {
        ...state,
        p24leads: action.payload,
        loading: false,
        completed: true,
        success: true
      };
    case P24_LEADS_FETCH_FAIL:
      return INITIAL_STATE;
    case PP_LISTINGS_ACTIVITY_FETCH_START:
      return {
        ...state,
        loading: true
      };
    case PP_LISTINGS_ACTIVITY_FETCH_SUCCUSS:
      return {
        ...state,
        ppstatus: action.payload,
        loading: false,
        completed: true,
        success: true
      };
    case PP_LISTINGS_ACTIVITY_FETCH_FAIL:
      return INITIAL_STATE;
      case FETCH_PPREF:
      return {
        ...state,
        loading: true
      };
    case FETCH_PPREF_SUCCESS:
      return {
        ...state,
        ppref: action.payload,
        loading: false,
        completed: true,
        success: true
      };
    case FETCH_PPREF_FAIL:
      return INITIAL_STATE;
    default:
      return state;
  }
};
